import script from "./FormErrors.vue?vue&type=script&lang=js"
export * from "./FormErrors.vue?vue&type=script&lang=js"

import "./FormErrors.vue?vue&type=style&index=0&id=aac59eb4&lang=scss"

const __exports__ = script;

export default __exports__